import Vue from 'vue'
import App from './App.vue'
import VueTheMask from 'vue-the-mask'

Vue.config.productionTip = false
Vue.use(VueTheMask);

import { ValidationProvider, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import Stepp4 from "@/Stepp4";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

if(document.getElementById('color-sample-checkout-app')){

    new Vue({
        components: {
            ValidationProvider
        },
        render: h => h(App),
    }).$mount('#color-sample-checkout-app')
}
if(document.getElementById('color-sample-checkout-app-thank')){

    new Vue({
        props: {
            currentStep: 4
        },
        render: h => h(Stepp4),
    }).$mount('#color-sample-checkout-app-thank')
}